module.exports = __webpack_public_path__ + "img/friendly-room-5.f3fe224c.jpg";